import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import {GraphQLWsLink} from "@apollo/client/link/subscriptions";
import {Observable, getMainDefinition} from "@apollo/client/utilities";
import {createClient} from "graphql-ws";
import {query} from "../utils/constants";
import {LicenseInfo} from "@mui/x-license";
import {onError} from "@apollo/client/link/error";
import {getIdTokenResult, onAuthStateChanged} from "firebase/auth";
import {auth} from "../firebase";
import {handleSignOut} from "../components/common/layout/Header";

const tokenInjectionLink = new ApolloLink((operation, forward) => {
  return new Observable((observer) => {
    const token = localStorage.getItem("authToken");

    const addTokenAndForward = (tokenToUse: string) => {
      operation.variables = {
        ...operation.variables,
        token: tokenToUse,
      };

      forward(operation).subscribe({
        next: observer.next.bind(observer),
        error: observer.error.bind(observer),
        complete: observer.complete.bind(observer),
      });
    };

    if (token) {
      addTokenAndForward(token);
    } else {
      handleSignOut(); // Redirect to login page
    }
  });
});

// Response Interceptor
const responseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    return response;
  });
});

const errorLink = onError(({graphQLErrors, operation, forward}) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      const message = err.message;
      if (
        message.includes("ID token has expired") ||
        message.includes("expired")
      ) {
        // Return a new Observable to handle retry
        return new Observable((observer) => {
          onAuthStateChanged(auth, async (user) => {
            if (user) {
              try {
                const tokenResult = await getIdTokenResult(user);
                const newToken = tokenResult.token;

                if (newToken) {
                  // Save new token
                  localStorage.setItem("authToken", newToken);

                  // Update the token in variables
                  operation.variables = {
                    ...operation.variables,
                    token: newToken,
                  };

                  // Retry the request
                  forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                  });
                } else {
                  observer.error("No token available");
                }
              } catch (err) {
                observer.error(err);
              }
            } else {
              observer.error(new Error("No user found"));
            }
          });
        });
      } else if (message.includes("ID token has invalid")) {
        // Handle unauthorized error
        console.error("User is not authorized");
        handleSignOut(); // Redirect to login page
      }
    }
  }
});

const eduateBackendServerLink = new HttpLink({
  uri: process.env.React_App_UAT_Backend_End_Point + query,
});

const eduateSubscriptionLink = new GraphQLWsLink(
  createClient({
    url: "ws://localhost:8081/subscriptions",
  })
);
LicenseInfo.setLicenseKey(
  "7d9c13a6d76787bfd11c68ad5c6ddaf1Tz0xMDk5MTgsRT0xNzczOTY0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
);
const eduateServer = split(
  ({query}) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  eduateSubscriptionLink,
  // eduateBackendServerLink,
  // rickandMortyOpenApi,
  ApolloLink.from([
    errorLink,
    // requestLink,
    tokenInjectionLink,
    responseLink,
    eduateBackendServerLink,
  ])
);

export const client = new ApolloClient({
  link: eduateServer,
  cache: new InMemoryCache({}),
  // defaultOptions: { query: { fetchPolicy: "network-only" } },
});
